var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.389,
    height: 29.021
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.594 18.819v7.7l10.632-11.2H28.39V3.415A2.414 2.414 0 0025.975 1H1v14.32h6.778",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  })));
}
export default SvgChatIcon;